import { supabase } from '../lib/supabase';

export interface CompanyProfile {
  kode_emiten: string;
  nama_emiten: string;
  alamat: string | null;
  telepon: string | null;
  email: string | null;
  website: string | null;
  fax: string | null;
  sektor: string | null;
  sub_sektor: string | null;
  industri: string | null;
  sub_industri: string | null;
  papan_pencatatan: string | null;
  tanggal_pencatatan: string | null;
  kegiatan_usaha_utama: string | null;
  bae: string | null;
  logo_url: string | null;
}

export interface CompanyShareholder {
  id: string;
  kode_emiten: string;
  nama: string;
  kategori: string | null;
  jumlah_saham: number | null;
  persentase: number | null;
  pengendali: boolean | null;
}

export interface CompanyDirector {
  id: string;
  kode_emiten: string;
  nama: string;
  jabatan: string | null;
  afiliasi: boolean | null;
}

export interface CompanyCommissioner {
  id: string;
  kode_emiten: string;
  nama: string;
  jabatan: string | null;
  independen: boolean | null;
}

export interface CompanySubsidiary {
  id: string;
  kode_emiten: string;
  nama: string;
  bidang_usaha: string | null;
  lokasi: string | null;
  mata_uang: string | null;
  persentase: number | null;
  jumlah_aset: number | null;
  satuan: string | null;
  status_operasi: string | null;
  tahun_komersil: string | null;
}

export interface EmitenProfileData {
  profile: CompanyProfile | null;
  shareholders: CompanyShareholder[];
  directors: CompanyDirector[];
  commissioners: CompanyCommissioner[];
  subsidiaries: CompanySubsidiary[];
}

export const fetchEmitenProfile = async (ticker: string): Promise<EmitenProfileData> => {
  try {
    const [
      profileResult,
      shareholdersResult,
      directorsResult,
      commissionersResult,
      subsidiariesResult
    ] = await Promise.all([
      supabase.from('company_profiles').select('*').eq('kode_emiten', ticker).maybeSingle(),
      supabase.from('company_shareholders').select('*').eq('kode_emiten', ticker),
      supabase.from('company_directors').select('*').eq('kode_emiten', ticker),
      supabase.from('company_commissioners').select('*').eq('kode_emiten', ticker),
      supabase.from('company_subsidiaries').select('*').eq('kode_emiten', ticker)
    ]);

    return {
      profile: profileResult.data,
      shareholders: shareholdersResult.data || [],
      directors: directorsResult.data || [],
      commissioners: commissionersResult.data || [],
      subsidiaries: subsidiariesResult.data || []
    };
  } catch (error) {
    console.error(`Error fetching emiten profile for ${ticker}:`, error);
    return {
      profile: null,
      shareholders: [],
      directors: [],
      commissioners: [],
      subsidiaries: []
    };
  }
};
